import { createSlice } from '@reduxjs/toolkit';
import customerSourceTypesActions from './actions';
import { CustomerSourceTypesState } from './types';

const initialState: CustomerSourceTypesState = {
  customerSourceTypes: [],
  customerSourceTypesError: null,
  customerSourceTypesLoading: false,
  customerSourceTypesIsEmpty: false,
};

export const customerSourceTypesSlice = createSlice({
  initialState,
  name: 'customerSourceTypes',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(customerSourceTypesActions.getCustomerSourceTypes.pending, (state) => {
      state.customerSourceTypesLoading = true;
    });

    builder.addCase(
      customerSourceTypesActions.getCustomerSourceTypes.fulfilled,
      (state, { payload: { customerSourceTypes } }) => {
        state.customerSourceTypesError = null;
        state.customerSourceTypesLoading = false;
        state.customerSourceTypes = customerSourceTypes;
        state.customerSourceTypesIsEmpty = !!!customerSourceTypes.length;
      }
    );

    builder.addCase(customerSourceTypesActions.getCustomerSourceTypes.rejected, (state, { error }) => {
      state.customerSourceTypesLoading = false;
      state.customerSourceTypesError = error;
    });
  },
});

export default customerSourceTypesSlice.reducer;
